import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesRequired } from './ITypeValidatesRequired';

export class RequiredValidator
  implements ValidatorInterface<ITypeValidatesRequired>
{
  name = 'Required';

  friendlyName = 'Required Field';

  arrayOnly = false;

  array = true;

  description = 'shared.properties.validators.required.description';

  types = null;

  properties = {
    value: {
      type: 'Boolean',
      default: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesRequired) {
    type.addRequiredValidator(this);
  }
}

const requiredValidator: ValidatorInterface<ITypeValidatesRequired> =
  new RequiredValidator(undefined);

ValidatorRegistry.register(RequiredValidator, requiredValidator.name);

export { requiredValidator };
